import React, {Component} from "react";
import DateRange from "../../../payment/common/dateRange";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleInput from "../../../../../modules/SimpleInput";
import M from "moment";

class FilterH23 extends Component {
    getValue = (name) => {
        return this.props.state.filterData?.filterH23?.[name];
    };

    setValue = (name, value) => {
        this.props.onValueChange("filterH23", name, value);
    };

    render() {
        const {options} = this.props;
        return (
            <>
                <DateRange
                    id="date_range_fjb"
                    label="Tanggal FJB"
                    startDateName="startDateFJB"
                    endDateName="endDateFJB"
                    data={this.getValue("tanggalFJB")}
                    onStartDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                    onEndDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                />
                <DateRange
                    id="date_range_jatuh_tempo_kpb1"
                    label="Tanggal Jatuh Tempo KPB 1"
                    startDateName="startDateJatuhTempoKPB1"
                    endDateName="endDateJatuhTempoKPB1"
                    data={this.getValue("tanggalJatuhTempoKPB1")}
                    onStartDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                    onEndDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                />
                <SimpleDDL
                    id="select_options_status_kpb_1"
                    box="search"
                    name="statusKPB1"
                    label="Status KPB 1"
                    isClearable
                    options={options.statusKPBOptions}
                    value={this.getValue("statusKPB1")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <DateRange
                    id="date_range_jatuh_tempo_kpb2"
                    label="Tanggal Jatuh Tempo KPB 2"
                    startDateName="startDateJatuhTempoKPB2"
                    endDateName="endDateJatuhTempoKPB2"
                    data={this.getValue("tanggalJatuhTempoKPB2")}
                    onStartDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                    onEndDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                />
                <SimpleDDL
                    id="select_options_status_kpb_2"
                    box="search"
                    name="statusKPB2"
                    label="Status KPB 2"
                    isClearable
                    options={options.statusKPBOptions}
                    value={this.getValue("statusKPB2")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <DateRange
                    id="date_range_jatuh_tempo_kpb3"
                    label="Tanggal Jatuh Tempo KPB 3"
                    startDateName="startDateJatuhTempoKPB3"
                    endDateName="endDateJatuhTempoKPB3"
                    data={this.getValue("tanggalJatuhTempoKPB3")}
                    onStartDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                    onEndDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                />
                <SimpleDDL
                    id="select_options_status_kpb_3"
                    box="search"
                    name="statusKPB3"
                    label="Status KPB 3"
                    isClearable
                    options={options.statusKPBOptions}
                    value={this.getValue("statusKPB3")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <DateRange
                    id="date_range_jatuh_tempo_kpb4"
                    label="Tanggal Jatuh Tempo KPB 4"
                    startDateName="startDateJatuhTempoKPB4"
                    endDateName="endDateJatuhTempoKPB4"
                    data={this.getValue("tanggalJatuhTempoKPB4")}
                    onStartDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                    onEndDateChange={(name, value) =>
                        this.setValue(name, M(value).format("DD-MM-YYYY"))
                    }
                />
                <SimpleDDL
                    id="select_options_status_kpb_4"
                    box="search"
                    name="statusKPB4"
                    label="Status KPB 4"
                    isClearable
                    options={options.statusKPBOptions}
                    value={this.getValue("statusKPB4")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <SimpleDDL
                            id="select_options_total_pengeluaran_1_tahun_terakhir"
                            box="search"
                            label="Operator"
                            name="pembandingPengeluaran"
                            isClearable
                            options={options.operatorOptions}
                            value={this.getValue("pembandingPengeluaran")}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleInput
                            id="select_text_total_pengeluaran_1_tahun_terakhir"
                            label="Total Pengeluaran 1 Tahun Terakhir"
                            name="totalPengeluaranSatuTahunTerakhir"
                            value={this.getValue("totalPengeluaranSatuTahunTerakhir")}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                    </div>
                </div>
                <SimpleDDL
                    id="select_options_job"
                    box="multiselect"
                    name="job"
                    label="Job"
                    options={options.jobOptions}
                    isClearable
                    value={this.getValue("job")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_part"
                    box="multiselect"
                    name="part"
                    label="Part"
                    options={options.partOptions}
                    isClearable
                    value={this.getValue("part")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <SimpleDDL
                            id="select_options_tanggal_service_terakhir"
                            box="search"
                            label="Operator"
                            name="pembandingServiceTerakhir"
                            options={options.operatorOptions}
                            isClearable
                            value={this.getValue("pembandingServiceTerakhir")}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDate
                            id="select_date_tanggal_service_terakhir"
                            label="Tanggal Service Terakhir"
                            name="tanggalServiceTerakhir"
                            date={this.getValue("tanggalServiceTerakhir")}
                            onChange={(value) => this.setValue("tanggalServiceTerakhir", M(value).format("DD-MM-YYYY"))}
                        />
                    </div>
                </div>
            </>
        )
    }

}

export default FilterH23